import { render } from "./PattyThread.vue?vue&type=template&id=2a1a1a3b&scoped=true"
import script from "./PattyThread.vue?vue&type=script&lang=js"
export * from "./PattyThread.vue?vue&type=script&lang=js"

import "./PattyThread.vue?vue&type=style&index=0&id=2a1a1a3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1a1a3b"]])

export default __exports__